import {add, isValid, parseISO} from 'date-fns';

export const DATE_TOKENS = ['today', 'end of next year'] as const;
type DateToken = (typeof DATE_TOKENS)[number];

const UNIT_TOKENS = ['year', 'month', 'week', 'day'] as const;

export const FORMAT_EXAMPLE = '[date_token] [+|-] [quantity] [unit]';

const parseToken = (token: DateToken): Date => {
  switch (token) {
    case 'today':
      return new Date(Date.now());
    case 'end of next year':
      return new Date(new Date().getFullYear() + 1, 11, 31, 23, 59, 59, 999);
  }
};

export const getExpressionRegex = (): RegExp => {
  const dateTokens = DATE_TOKENS.join('|');
  const unitTokens = UNIT_TOKENS.join('|');
  return new RegExp(`(?<token>${dateTokens})\\s(?<operator>[+-])\\s(?<quantity>\\d+)\\s(?<unit>${unitTokens})s?`);
};

const parseExpression = (input: string): Date => {
  const {token, operator, quantity, unit} = getExpressionRegex().exec(input)?.groups ?? {};
  const units = unit.endsWith('s') ? unit : `${unit}s`;
  return add(parseToken(token as DateToken), {[units]: parseInt(quantity) * (operator === '+' ? 1 : -1)});
};

export const parseDateExpression = (input: string): Date => {
  if (DATE_TOKENS.includes(input as DateToken)) return parseToken(input as DateToken);
  if (isValid(parseISO(input))) return new Date(input);
  if (getExpressionRegex().test(input)) return parseExpression(input);

  throw new Error(`Invalid date expression: ${input}. It should be in the format "${FORMAT_EXAMPLE}"`);
};
